import { buttonTagStyle } from './Tag.styles.css';

import { TickSmall } from '@zoopla-eng/zds/icons';
import React, { PropsWithChildren } from 'react';

export const QuickFilter: React.FC<
    PropsWithChildren<{
        isActive: boolean;
        onClick: () => void;
    }>
> = ({ isActive, onClick, children }) => (
    <button
        className={buttonTagStyle({ isActive })}
        aria-pressed={isActive}
        onClick={onClick}
    >
        {isActive ? <TickSmall color="currentColor" /> : null}
        {children}
    </button>
);
